// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProBadge":"beu_a bib_rj bib_rk bib_vh bib_eb bib_vf bib_gu bib_kh"};